import { useState, useEffect } from 'react';

export const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
        const listener = event => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
        };
    }, [ref, handler],
    );
};

export const useAuthStatus = () => {
    const [isOnline, setIsOnline] = useState(0);

    useEffect(() => {
        setIsOnline(window.localStorage.getItem('isLogin'));
    }, []);

    return isOnline;
};